import MultipleOptionsField from "./MultipleOptionField";

/*
* Options must look like:
* [ [{code: "code", name: "name"}, ...]
*/

//FIXME THIS NEEDS TO BE REFACTORIZED WITH MULTIPLEOPTIONFIELD. WE CAN USE SOME CLOSURES FOR SOME METHODS BUT STILL

export default class CustomerGroupMultipleOptionField extends MultipleOptionsField {
    hasThisValue(value) {
        return this.value.some(v => v.name === value.name && v.code === value.code);
    }

}